import React, { PropsWithChildren } from "react";
import { useDispatch } from "react-redux";
import { useOnLocationChange } from "../hooks/useOnLocationChange";
import { resetNotifications } from "../store/notification/slice";
import { trackPageView } from "helpers/analyticsHelpers";
import { useTheme } from "hooks/useTheme";

export const AppWrapper: React.FC<PropsWithChildren> = ({ children }) => {
    const dispatch = useDispatch();
    const { theme } = useTheme();
    document.documentElement.setAttribute("data-theme", theme);

    useOnLocationChange(() => {
        // clear all notifications on page change
        dispatch(resetNotifications());
        trackPageView(window.location.pathname);
    });

    return <>{children}</>;
};
